import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const PaymentAmountModalUI = ({
  context, successMsg, errorList, setErrorList, submitted,
  onSubmit, onCancelClick,updateMode,
  paidDate, onPaidDateChange, paidDateError, setPaidDateError,
  amount, onAmountChange, amountError, setAmountError
}) => (
  <ModalFormUI
    context={context}
    titleLabel='Add Payment'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputDateUI context={context} name='paidDate'
      label='Paid Date' selectedDateISO={paidDate}
      onChange={onPaidDateChange} error={paidDateError} setError={setPaidDateError}
    />
    <InputTextSF type='text' name='amount' 
      label='Payment Amount' value={amount}
      onChange={onAmountChange} error={amountError} setError={setAmountError}
    />
  </ModalFormUI>
)

export default PaymentAmountModalUI
